module.exports = __webpack_public_path__ + "img/universkin-h-active-icon.3b500e1b.svg";